const SITE_TITLE = 'INCF Japan Node';
const SITE_SLOGAN = 'Top';
// Replaces the Universal Analytics property (UA-2365647-1), shut down in 2023.
const GOOGLE_ANALYTICS_TRACKING_ID = 'G-FQK4EVM4WN';
const XOONIPS_ITEMTYPES = ['journal', 'article', 'generaldata'];
const PICO_MODULES = [
    'aboutus',
    'aini',
    'hackathon',
    'joinus',
    'link',
    'nbni',
    'program',
    'publication',
    'resource',
    'tutorial',
];
const BULLETIN_MODULES = ['news'];

// Vite's BASE_URL always carries a trailing slash ('/' when the app is served
// from the document root). Strip it so it can be concatenated the same way
// CRA's Config.BASE_URL was.
const BASE_URL = import.meta.env.BASE_URL.replace(/\/$/, '');

export type MultiLang = 'en' | 'ja';

const Config = {
    SITE_TITLE,
    SITE_SLOGAN,
    GOOGLE_ANALYTICS_TRACKING_ID,
    XOONIPS_ITEMTYPES,
    PICO_MODULES,
    BULLETIN_MODULES,
    BASE_URL,
};

export default Config;
